import {map} from 'lodash';
import {TextLoop} from 'react-text-loop-next';
import {Putintouse, AIExploration, FusionData, Right} from '@baidu/xicon-react';
import useGetCampaign, {CampaignConfig} from '@/hooks/useCampaign';

const SloganWrap = () => {
    const campaignConfig = useGetCampaign();
    const campaignLoopChildren = map(campaignConfig, (item: CampaignConfig) => {
        const {href, campaignText, campaignLinkText} = item;
        return (
            <div className="campaign-text-wrap">
                <span className="campaign-text">{campaignText}</span>
                <span style={{marginLeft: 24}}>
                    <a className="campaign-link-text" href={href}>
                        {campaignLinkText}
                    </a>
                    <Right theme="line" color="#2468f2" size={16} strokeLinejoin="round" />
                </span>
            </div>
        );
    });
    return (
        <div className="slogan-wrap">
            <div className="first-slogan">百度智能云 云智一体深入产业</div>
            <div className="second-slogan">
                <div>
                    <Putintouse className="slogan-icon" theme="line" color="#303540" size={16} strokeLinejoin="round" />
                    聚焦行业核心场景，打造行业标杆应用
                </div>
                <div>
                    <AIExploration
                        className="slogan-icon"
                        theme="line"
                        color="#303540"
                        size={16}
                        strokeLinejoin="round"
                    />
                    全栈自研的AI大底座，满足产业对智算基础设施的需求
                </div>
                <div>
                    <FusionData className="slogan-icon" theme="line" color="#303540" size={16} strokeLinejoin="round" />
                    先进的技术和丰富的解决方案，与实体经济深度融合，共创价值
                </div>
            </div>
            <div id="campaign" className="campaign-link">
                <img
                    width={20}
                    height={20}
                    src="https://bce.bdstatic.com/eop-plat/assets/img/login/login-banner-icon.png"
                />
                {/* eslint-disable-next-line */}
                <TextLoop interval={5000} children={campaignLoopChildren} />
            </div>
        </div>
    );
};

export const LeftWrapV1 = () => {
    return (
        <div className="left-wrap">
            <SloganWrap />
        </div>
    );
};

const LeftWrapV2 = () => {
    return (
        <div className="left-wrap-v2">
            <a
                data-track-action="click"
                data-track-category="登录页左侧营销位"
                data-track-name="点击"
                data-track-value="click_left_banner"
                href="https://cloud.baidu.com/product-s/qianfan_home"
                target="_blank"
                rel="noreferrer"
            >
                <img
                    width={500}
                    height={600}
                    src="https://bce.bdstatic.com/eop-plat/assets/img/login/left-banner-20250320.png"
                />
            </a>
        </div>
    );
};

const LeftWrap = () => {
    return <LeftWrapV2 />;
};

export default LeftWrap;
